module.exports = __webpack_public_path__ + "static/img/404.c04009f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/404.png
// module id = CgFv
// module chunks = 29